import { useEffect, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import "./PlanningWes1.css";
import { formatGermanFixedBy2 } from "../../../utility/NumberFormat";

const PlanningWes1 = (props) => {
  const {
    vkPlanningAllInOneNew,
    handleChangeWES,
    handleBlurWES,
    formatGermanInputForDecimal,
    isEditable,
  } = props;
  const [checkBox1, setCheckBox1] = useState(true);
  const [checkBox2, setCheckBox2] = useState(true);
  const [checkBox3, setCheckBox3] = useState(true);

  const getCheckValue = (e) => {
    const { name, checked } = e.target;
    if (name === "Wareneingang") {
      setCheckBox1(checked);
    } else if (name === "Abschrift") {
      setCheckBox2(checked);
    } else if (name === "Eingangskalkulation") {
      setCheckBox3(checked);
    }
  };

  const kollIndex = vkPlanningAllInOneNew?.PARTP?.findIndex(
    (row) => row.typId === "KOLL",
  );

  const nosIndex = vkPlanningAllInOneNew?.PARTP?.findIndex(
    (row) => row.typId === "NOS",
  );

  const kollRow = vkPlanningAllInOneNew?.PARTP?.[kollIndex];
  const nosRow = vkPlanningAllInOneNew?.PARTP?.[nosIndex];

  const totalWareAbschriftPercent =
    (Number(kollRow?.percred || 0) + Number(nosRow?.percred || 0)) / 2 || null;

  const totalPercent =
    Number(kollRow?.percValue || 0) + Number(nosRow?.percValue || 0) || "";

  const totalPercentValue =
    Number(kollRow?.partAmount || 0) + Number(nosRow?.partAmount || 0) || "";

  const totalVoorderPercent =
    Number(kollRow?.prePerc || 0) + Number(nosRow?.prePerc || 0) || "";

  const totalVoorderPercentValue =
    Number(kollRow?.preAmount || 0) + Number(nosRow?.preAmount || 0) || "";

  const totalNachoorderPercent =
    100 - Number(kollRow?.prePerc) + (100 - Number(nosRow?.prePerc)) || "";

  const totalNachoorderPercentValue =
    Number(kollRow?.reAmount || 0) + Number(nosRow?.reAmount || 0) || "";

  const avgWareEingangAufschlag =
    (Number(kollRow?.estimatedCalc || 0) + Number(nosRow?.estimatedCalc || 0)) /
      2 || null;

  // console.log("vkplanning in one new from PARTP?", vkPlanningAllInOneNew);
  const totalWareEingangAufschlag =
    ((avgWareEingangAufschlag + 100) /
      (100 - vkPlanningAllInOneNew?.HDP?.DIPE)) *
      100 -
      100 || "";

  const avgWareEingangAbschlag =
    (Number(kollRow?.estimatedCalcDisc || 0) +
      Number(nosRow?.estimatedCalcDisc || 0)) /
      2 || null;

  const totalWareEingangAbschlag =
    100 -
      ((100 - avgWareEingangAbschlag) *
        (100 - vkPlanningAllInOneNew?.HDP?.DIPE)) /
        100 || "";

  const avgWareNachorderAusgangsAufschlag =
    (Number(kollRow?.outgoingCalc || 0) +
      Number(nosRow?.outgoingCalc || 0)) /
      2 || null;

  // const totalWareNachorderAusgangsAufschlag =
  //   (((avgWareEingangAufschlag + 100) * (100 - totalWareAbschriftPercent)) /
  //     100 /
  //     (100 - vkPlanningAllInOneNew?.HDP?.DIPE)) *
  //     100 -
  //     100 || "";

  const totalWareNachorderAusgangsAufschlag = avgWareNachorderAusgangsAufschlag;

  const avgWareNachorderAusgangsAbschlag =
    (Number(kollRow?.outgoingCalcDisc || 0) +
      Number(nosRow?.outgoingCalcDisc || 0)) /
      2 || null;

  // const totalWareNachorderAusgangsAbschlag =
  //   100 -
  //     ((100 - avgWareNachorderAusgangsAbschlag) *
  //       (100 - vkPlanningAllInOneNew?.HDP?.DIPE)) /
  //       100 || "";

  const totalWareNachorderAusgangsAbschlag = avgWareNachorderAusgangsAbschlag;
  
  const totalWareAuslieferungsQuote =
    (Number(kollRow?.delivQuota || 0) + Number(nosRow?.delivQuota || 0)) / 2 ||
    null;

  const totalWareLUG =
    (Number(kollRow?.lugPlan || 0) + Number(nosRow?.lugPlan || 0)) / 2 || null;

  const totalBestandAvg =
    Math.round(
      Number(kollRow?.planStockAvail || 0) +
        Number(nosRow?.planStockAvail || 0),
    ) || null;

  // console.log('get value input', getValueInput)
  // console.log('copy tempalte?', copyTemplate)
  console.log("vkplanningnew from wes?", vkPlanningAllInOneNew);

  return (
    <div className=" planing_wes1_main">
      {/*  */}
      <div className="wes1CheckboxMain mb-2">
        <Row className="p-2">
          {/* <div className="wes1CheckboxMain"> */}
          <Col className="wes1CheckboxMainContainer">
            <div className="wes1CheckboxMainContainerinputMain">
              <input
                type="checkbox"
                className="wes1CheckboxMainContainerinputTag"
                onChange={getCheckValue}
                checked={checkBox1}
                name="Wareneingang"
              />
            </div>
            <div className="wes1CheckboxMainContainertext">Wareneingang</div>
          </Col>
          <Col className="wes1CheckboxMainContainer">
            <div className="wes1CheckboxMainContainerinputMain">
              <input
                type="checkbox"
                className="wes1CheckboxMainContainerinputTag"
                onChange={getCheckValue}
                checked={checkBox2}
                name="Abschrift"
              />
            </div>
            <div className="wes1CheckboxMainContainertext">
              Vororder Nachorder
            </div>
          </Col>
          <Col className="wes1CheckboxMainContainer">
            <div className="wes1CheckboxMainContainerinputMain">
              <input
                type="checkbox"
                className="wes1CheckboxMainContainerinputTag"
                onChange={getCheckValue}
                checked={checkBox3}
                name="Eingangskalkulation"
              />
            </div>
            <div className="wes1CheckboxMainContainertext">
              Eingangskalkulation
            </div>
          </Col>
          {/* </div> */}
        </Row>
      </div>
      {/*  */}
      <div className="table-scroll-wrapper">
        <Table
          bordered
          hover
          // responsive
          size="sm"
          className="planing_wes1-table1 p-0 m-0"
          align-middle="text-center"
        >
          <thead className="table-warning">
            <tr>
              <th rowSpan={1}></th>
              {checkBox1 && <th colSpan={2}>Wareneingang</th>}

              {checkBox2 && (
                <>
                  <th colSpan={2}>Vororder</th>
                  <th colSpan={2}>Nachorder</th>
                </>
              )}

              {checkBox3 && <th colSpan={8}></th>}
            </tr>

            <tr>
              <th colSpan={1}></th>
              {checkBox1 && (
                <>
                  <th rowSpan={2}>Prozent</th>
                  <th rowSpan={2}>Wert</th>
                </>
              )}

              {checkBox2 && (
                <>
                  <th rowSpan={2}>%</th>
                  <th rowSpan={2}>Wert</th>
                  <th>%</th>
                  <th>Wert</th>
                </>
              )}

              {checkBox3 && (
                <>
                  <th>
                    <div>Eingangskalkulation</div>
                    <div> (Aufschlag)</div>
                  </th>
                  <th>
                    <div>Eingangskalkulation</div>
                    <div> (Abschlag)</div>
                  </th>
                  <th>
                    <div>Ausgangskalkulation</div>
                    <div> (Aufschlag)</div>
                  </th>
                  <th>
                    <div>Ausgangskalkulation</div>
                    <div> (Abschlag)</div>
                  </th>
                  <th>
                    <div>Auslieferungs</div>
                    <div>quote</div>
                  </th>
                  <th>LUG</th>
                  <th>
                    <div>Abschrift</div>
                    <div>prozentual</div>
                  </th>
                  <th>
                    <div>Bestand</div>
                    <div> Ø</div>
                  </th>
                </>
              )}
            </tr>
          </thead>

          <tbody className="vkplanning_wes1-tbody">
            {/* Row 1 */}
            <tr>
              <td
                style={{ background: "rgb(247, 246, 215)" }}
                className="wes1td"
                colSpan={1}
              >
                Kollektion
              </td>
              {checkBox1 ? (
                <>
                  <td>
                    <input
                      className="wes1InputTag"
                      name="percValue"
                      // value={formatGermanFixedBy2(vkPlanningAllInOneNew?.WP?.kollSumTotalPct || "") ?? ""}
                      value={
                        formatGermanFixedBy2(kollRow?.percValue || "") ?? ""
                      }
                      onChange={(e) => handleChangeWES("PARTP", e, kollIndex)}
                      onBlur={(e) => handleBlurWES("PARTP", e, kollIndex)}
                      autoComplete="off"
                      disabled={isEditable === false}
                    />
                  </td>
                  <td className="td_as_output">
                    {/* <input
                      className="wes1InputTag"
                      name="partAmount"
                      onChange={(e) => handleChangeWES("PARTP", e, kollIndex)}
                      style={{
                        background: "rgb(247, 246, 215)",
                        border: "none",
                      }}
                      value={
                        formatGermanInputForDecimal(
                          Math.round(kollRow?.partAmount)
                        ) ?? ""
                      }
                      disabled
                    /> */}
                    {formatGermanInputForDecimal(
                      Math.round(kollRow?.partAmount),
                    ) ?? ""}
                  </td>
                </>
              ) : null}
              {checkBox2 ? (
                <>
                  <td>
                    {" "}
                    <input
                      className="wes1InputTag"
                      autoComplete="off"
                      name="prePerc"
                      onChange={(e) => handleChangeWES("PARTP", e, kollIndex)}
                      onBlur={(e) => handleBlurWES("PARTP", e, kollIndex)}
                      // value={
                      //   vkPlanningAllInOneNew?.WP?.kollSumVororderPct ?? ""
                      // }
                      // value={formatGermanFixedBy2(vkPlanningAllInOneNew?.WP?.kollSumVororderPct || "") || ""}
                      value={formatGermanFixedBy2(kollRow?.prePerc || "") || ""}
                      disabled={isEditable === false}
                    />
                  </td>
                  <td className="td_as_output">
                    {/* <input
                      className="wes1InputTag"
                      autoComplete="off"
                      name="preAmount"
                      onChange={(e) => handleChangeWES("PARTP", e, kollIndex)}
                      value={
                        formatGermanInputForDecimal(
                          Math.round(kollRow?.preAmount)
                        ) ?? ""
                      }
                      style={{
                        background: "rgb(247, 246, 215)",
                        border: "none",
                      }}
                      // disabled ={isEditable=== true || disbaled}
                      disabled
                    /> */}
                    {formatGermanInputForDecimal(
                      Math.round(kollRow?.preAmount),
                    ) ?? ""}
                  </td>
                  <td className="td_as_output">
                    {/* <input
                      className="wes1InputTag"
                      autoComplete="off"
                      name="prePerc"
                      // onChange={(e) => handleChangeWES("PARTP", e, kollIndex)}
                      // onBlur={(e) => handleBlurWES("PARTP", e, kollIndex)}
                      // value={
                      //   formatGermanFixedBy2(vkPlanningAllInOneNew?.WP?.kollSumNachorderPct || "") || ""
                      // }
                      value={
                        formatGermanFixedBy2(100 - kollRow?.prePerc || "") || ""
                      }
                      style={{
                        background: "rgb(247, 246, 215)",
                        border: "none",
                      }}
                      // disabled = {isEditable=== true || disbale}
                      disabled
                    /> */}
                    {formatGermanFixedBy2(100 - kollRow?.prePerc || "") || ""}
                  </td>
                  <td className="td_as_output">
                    {/* <input
                      className="wes1InputTag"
                      autoComplete="off"
                      name="reAmount"
                      onChange={(e) => handleChangeWES("PARTP", e, kollIndex)}
                      value={
                        formatGermanInputForDecimal(
                          Math.round(kollRow?.reAmount)
                        ) ?? ""
                      }
                      style={{
                        background: "rgb(247, 246, 215)",
                        border: "none",
                      }}
                      // disabled = {isEditable=== true || disbaled}
                      disabled
                    /> */}
                    {formatGermanInputForDecimal(
                      Math.round(kollRow?.reAmount),
                    ) ?? ""}
                  </td>
                </>
              ) : null}

              {checkBox3 ? (
                <>
                  <td>
                    <input
                      className="wes1InputTag"
                      autoComplete="off"
                      name="estimatedCalc"
                      value={formatGermanFixedBy2(kollRow?.estimatedCalc)}
                      onChange={(e) => handleChangeWES("PARTP", e, kollIndex)}
                      onBlur={(e) => handleBlurWES("PARTP", e, kollIndex)}
                      maxLength={14}
                      disabled={isEditable === false}
                    />
                  </td>
                  <td>
                    <input
                      className="wes1InputTag"
                      autoComplete="off"
                      name="estimatedCalcDisc"
                      value={formatGermanFixedBy2(kollRow?.estimatedCalcDisc)}
                      onChange={(e) => handleChangeWES("PARTP", e, kollIndex)}
                      onBlur={(e) => handleBlurWES("PARTP", e, kollIndex)}
                      maxLength={14}
                      disabled={isEditable === false}
                    />
                  </td>
                  <td className="td_as_output">
                    {/* <input
                      className="wes1InputTag"
                      autoComplete="off"
                      name="outgoingCalc"
                      value={formatGermanFixedBy2(kollRow?.outgoingCalc)}
                      onChange={(e) => handleChangeWES("PARTP", e, kollIndex)}
                      onBlur={(e) => handleBlurWES("PARTP", e, kollIndex)}
                      maxLength={14}
                      disabled
                    /> */}
                    {formatGermanFixedBy2(kollRow?.outgoingCalc)}
                  </td>
                  <td className="td_as_output">
                    {/* <input
                      className="wes1InputTag"
                      autoComplete="off"
                      name="outgoingCalcDisc"
                      value={formatGermanFixedBy2(kollRow?.outgoingCalcDisc)}
                      maxLength={14}
                      disabled
                    /> */}
                    {formatGermanFixedBy2(kollRow?.outgoingCalcDisc)}
                  </td>
                  <td>
                    <input
                      className="wes1InputTag"
                      autoComplete="off"
                      name="delivQuota"
                      value={formatGermanFixedBy2(kollRow?.delivQuota)}
                      onChange={(e) => handleChangeWES("PARTP", e, kollIndex)}
                      onBlur={(e) => handleBlurWES("PARTP", e, kollIndex)}
                      maxLength={14}
                      disabled={isEditable === false}
                    />
                  </td>
                  <td>
                    <input
                      className="wes1InputTag"
                      autoComplete="off"
                      name="lugPlan"
                      value={formatGermanFixedBy2(kollRow?.lugPlan)}
                      onChange={(e) => handleChangeWES("PARTP", e, kollIndex)}
                      onBlur={(e) => handleBlurWES("PARTP", e, kollIndex)}
                      maxLength={14}
                      disabled={isEditable === false}
                    />
                  </td>
                  <td>
                    <input
                      className="wes1InputTag"
                      name="percred"
                      value={formatGermanFixedBy2(kollRow?.percred)}
                      onChange={(e) => handleChangeWES("PARTP", e, kollIndex)}
                      onBlur={(e) => handleBlurWES("PARTP", e, kollIndex)}
                      maxLength={14}
                      disabled={isEditable === false}
                    />
                  </td>
                  {/* <td
                  style={{
                    background: "rgb(247, 246, 215)",
                    textAlign: "right",
                    ppadingRight: "1vw",
                  }}
                >
                  67.833
                </td> */}
                  <td className="td_as_output">
                    {/* <input
                      className="wes1InputTag"
                      name="planStockAvail"
                      value={formatGermanInputForDecimal(
                        Math.round(kollRow?.planStockAvail)
                      )}
                      onChange={(e) => handleChangeWES("PARTP", e, kollIndex)}
                      onBlur={(e) => handleBlurWES("PARTP", e, kollIndex)}
                      maxLength={14}
                      disabled={isEditable === false}
                    /> */}
                    {formatGermanInputForDecimal(
                      Math.round(kollRow?.planStockAvail),
                    )}
                  </td>
                </>
              ) : null}
            </tr>

            {/* Row 2 */}
            <tr>
              <td
                style={{ background: "rgb(247, 246, 215)" }}
                className="wes1td"
                colSpan={1}
              >
                NOS
              </td>
              {checkBox1 ? (
                <>
                  <td style={{ background: "rgb(212, 236, 251)" }}>
                    <input
                      className="wes1InputTag1"
                      name="percValue"
                      onChange={(e) => handleChangeWES("PARTP", e, nosIndex)}
                      onBlur={(e) => handleBlurWES("PARTP", e, nosIndex)}
                      // value={formatGermanFixedBy2(vkPlanningAllInOneNew?.WP?.nosSumTotalPct || "") || ""}
                      value={
                        formatGermanFixedBy2(nosRow?.percValue || "") || ""
                      }
                      autoComplete="off"
                      disabled={isEditable === false}
                    />
                  </td>
                  <td className="td_as_output">
                    {/* <input
                      className="wes1InputTag"
                      name="partAmount"
                      onChange={(e) => handleChangeWES("PARTP", e, nosIndex)}
                      style={{ background: "rgb(247, 246, 215)", border: 'none' }}
                      value={
                        formatGermanInputForDecimal(
                          Math.round(nosRow?.partAmount)
                        ) ?? ""
                      }
                      disabled
                    /> */}
                    {formatGermanInputForDecimal(
                      Math.round(nosRow?.partAmount),
                    ) ?? ""}
                  </td>
                </>
              ) : null}
              {checkBox2 ? (
                <>
                  <td style={{ background: "rgb(212, 236, 251)" }}>
                    <input
                      className="wes1InputTag1"
                      name="prePerc"
                      onChange={(e) => handleChangeWES("PARTP", e, nosIndex)}
                      onBlur={(e) => handleBlurWES("PARTP", e, nosIndex)}
                      value={formatGermanFixedBy2(nosRow?.prePerc || "") || ""}
                      disabled={isEditable === false}
                    />
                  </td>
                  <td className="td_as_output">
                    {/* <input
                      className="wes1InputTag"
                      autoComplete="off"
                      name="preAmount"
                      value={
                        formatGermanInputForDecimal(
                          Math.round(nosRow?.preAmount)
                        ) ?? ""
                      }
                      style={{ background: "rgb(247, 246, 215)", border: "none" }}
                      disabled
                    /> */}
                    {formatGermanInputForDecimal(
                      Math.round(nosRow?.preAmount),
                    ) ?? ""}
                  </td>
                  <td className="td_as_output">
                    {/* <input
                      className="wes1InputTag"
                      autoComplete="off"
                      name="rePerc"
                      // onChange={(e) => handleChangeWES("PARTP", e, nosIndex)}
                      // onBlur={(e) => handleBlurWES("PARTP", e, nosIndex)}
                      value={
                        formatGermanFixedBy2(100 - nosRow?.prePerc || "") || ""
                      }
                      style={{
                        background: "rgb(247, 246, 215)",
                        border: "none",
                      }}
                      disabled
                    /> */}
                    {formatGermanFixedBy2(100 - nosRow?.prePerc || "") || ""}
                  </td>
                  <td className="td_as_output">
                    {/* <input
                      className="wes1InputTag"
                      autoComplete="off"
                      name="reAmount"
                      // onChange={(e) => handleChangeWES("PARTP", e, nosIndex)}
                      value={
                        formatGermanInputForDecimal(
                          Math.round(nosRow?.reAmount)
                        ) || ""
                      }
                      style={{
                        background: "rgb(247, 246, 215)",
                        border: "none",
                      }}
                      disabled
                    /> */}
                    {formatGermanInputForDecimal(
                      Math.round(nosRow?.reAmount),
                    ) || ""}
                  </td>
                </>
              ) : null}

              {checkBox3 ? (
                <>
                  <td style={{ background: "rgb(212, 236, 251)" }}>
                    <input
                      className="wes1InputTag1"
                      autoComplete="off"
                      name="estimatedCalc"
                      value={formatGermanFixedBy2(nosRow?.estimatedCalc)}
                      onChange={(e) => handleChangeWES("PARTP", e, nosIndex)}
                      onBlur={(e) => handleBlurWES("PARTP", e, nosIndex)}
                      maxLength={14}
                      disabled={isEditable === false}
                    />
                  </td>
                  <td style={{ background: "rgb(212, 236, 251)" }}>
                    <input
                      className="wes1InputTag1"
                      autoComplete="off"
                      name="estimatedCalcDisc"
                      value={formatGermanFixedBy2(nosRow?.estimatedCalcDisc)}
                      onChange={(e) => handleChangeWES("PARTP", e, nosIndex)}
                      onBlur={(e) => handleBlurWES("PARTP", e, nosIndex)}
                      maxLength={14}
                      disabled={isEditable === false}
                    />
                  </td>
                  <td className="td_as_output">
                    {/* <input
                      className="wes1InputTag1"
                      autoComplete="off"
                      name="outgoingCalc"
                      value={formatGermanFixedBy2(nosRow?.outgoingCalc)}
                      maxLength={14}
                      disabled
                    /> */}
                    {formatGermanFixedBy2(nosRow?.outgoingCalc)}
                  </td>
                  <td className="td_as_output">
                    {/* <input
                      className="wes1InputTag1"
                      autoComplete="off"
                      name="outgoingCalcDisc"
                      defaultValue=""
                      value={formatGermanFixedBy2(nosRow?.outgoingCalcDisc)}
                      maxLength={14}
                      disabled
                    /> */}
                    {formatGermanFixedBy2(nosRow?.outgoingCalcDisc)}
                  </td>
                  <td style={{ background: "rgb(212, 236, 251)" }}>
                    <input
                      className="wes1InputTag1"
                      defaultValue=""
                      autoComplete="off"
                      name="delivQuota"
                      value={formatGermanFixedBy2(nosRow?.delivQuota)}
                      onChange={(e) => handleChangeWES("PARTP", e, nosIndex)}
                      onBlur={(e) => handleBlurWES("PARTP", e, nosIndex)}
                      maxLength={14}
                      disabled={isEditable === false}
                    />
                  </td>

                  <td style={{ background: "rgb(212, 236, 251)" }}>
                    <input
                      className="wes1InputTag1"
                      defaultValue=""
                      name="lugPlan"
                      autoComplete="off"
                      value={formatGermanFixedBy2(nosRow?.lugPlan)}
                      onChange={(e) => handleChangeWES("PARTP", e, nosIndex)}
                      onBlur={(e) => handleBlurWES("PARTP", e, nosIndex)}
                      maxLength={14}
                      disabled={isEditable === false}
                    />
                  </td>
                  <td style={{ background: "rgb(212, 236, 251)" }}>
                    <input
                      className="wes1InputTag1"
                      defaultValue=""
                      name="percred"
                      autoComplete="off"
                      value={formatGermanFixedBy2(nosRow?.percred)}
                      onChange={(e) => handleChangeWES("PARTP", e, nosIndex)}
                      onBlur={(e) => handleBlurWES("PARTP", e, nosIndex)}
                      maxLength={14}
                      disabled={isEditable === false}
                    />
                  </td>
                  {/* <td
                  style={{ background: "rgb(236 245 166)", textAlign: "right" }}
                >
                  67.833
                </td> */}
                  <td className="td_as_output">
                    {/* <input
                      className="wes1InputTag1"
                      defaultValue=""
                      name="planStockAvail"
                      autoComplete="off"
                      value={formatGermanInputForDecimal(
                        Math.round(nosRow?.planStockAvail)
                      )}
                      // onChange={(e) => handleChangeWES("PARTP", e, nosIndex)}
                      // onBlur={(e) => handleBlurWES("PARTP", e, nosIndex)}
                      maxLength={14}
                      // disabled={isEditable === false}
                      disabled
                    /> */}
                    {formatGermanInputForDecimal(
                      Math.round(nosRow?.planStockAvail),
                    )}
                  </td>
                </>
              ) : null}
            </tr>
            {(checkBox1 || checkBox2 || checkBox3) && (
              <>
                {/* <tr className="wes1_gap-row"><td colSpan={15}>&nbsp;</td></tr> */}
                {/* <tr className="wes1_gap-row"><td colSpan={15}>&nbsp;</td></tr> */}
                {/* <tr className="wes1_gap-row"><td colSpan={15}>&nbsp;</td></tr>
              <tr className="wes1_gap-row"><td colSpan={15}>&nbsp;</td></tr> */}
              </>
            )}
          </tbody>

          <tfoot>
            <tr>
              <td className="total_row_for_wes2" colSpan={1}>
                Gesamt
              </td>
              {checkBox1 ? (
                <>
                  <td colSpan={1} className="total_row_for_wes1">
                    {/* {totalPercent} */}
                    <input
                      className="wes1InputTagTotal"
                      autoComplete="off"
                      value={formatGermanFixedBy2(totalPercent)}
                      disabled
                    />
                    {/* {formatGermanFixedBy2(totalPercent)} */}
                  </td>
                  <td className="total_td_as_output">
                    {/* <div className="total_row_for_wes-inside"> */}
                    {/* {formatGermanInputForDecimal(Math.round(totalPercentValue)) ?? ""} */}
                    <input
                      className="wes1InputTagTotal"
                      autoComplete="off"
                      value={
                        formatGermanInputForDecimal(
                          Math.round(totalPercentValue),
                        ) ?? ""
                      }
                      disabled
                    />
                    {/* </div> */}
                  </td>
                </>
              ) : null}
              {checkBox2 ? (
                <>
                  <td className="total_row_for_wes1">
                    <input
                      className="wes1InputTagTotal"
                      autoComplete="off"
                      value={formatGermanFixedBy2(totalVoorderPercent)}
                      disabled
                    />
                    {/* {totalVoorderPercent} */}
                  </td>
                  <td className="total_td_as_output">
                    {/* <div className="total_row_for_wes-inside"> */}
                    {/* {formatGermanInputForDecimal(Math.round(totalVoorderPercentValue)) ?? ""} */}
                    <input
                      className="wes1InputTagTotal"
                      autoComplete="off"
                      value={
                        formatGermanInputForDecimal(
                          Math.round(totalVoorderPercentValue),
                        ) ?? ""
                      }
                      disabled
                    />
                    {/* </div> */}
                  </td>
                  <td className="total_td_as_output">
                    {/* {totalNachoorderPercent} */}
                    <input
                      className="wes1InputTagTotal"
                      autoComplete="off"
                      value={formatGermanFixedBy2(totalNachoorderPercent)}
                      disabled
                    />
                  </td>
                  <td className="total_td_as_output">
                    {/* <div className="total_row_for_wes-inside"> */}
                    {/* {formatGermanInputForDecimal(Math.round(totalNachoorderPercentValue)) ?? ""} */}
                    <input
                      className="wes1InputTagTotal"
                      autoComplete="off"
                      value={
                        formatGermanInputForDecimal(
                          Math.round(totalNachoorderPercentValue),
                        ) ?? ""
                      }
                      disabled
                    />
                    {/* </div> */}
                  </td>
                </>
              ) : null}
              {checkBox3 ? (
                <>
                  <td className="total_row_for_wes1">
                    {/* <div className="total_row_for_wes1-inside"> */}
                    {/* {totalWareEingangAufschlag} */}
                    <input
                      className="wes1InputTagTotal"
                      autoComplete="off"
                      value={
                        formatGermanFixedBy2(totalWareEingangAufschlag) ?? ""
                      }
                      disabled
                    />
                    {/* </div> */}
                  </td>
                  <td className="total_row_for_wes1">
                    {/* <div className="total_row_for_wes1-inside"> */}
                    {/* {totalWareEingangAbschlag} */}
                    <input
                      className="wes1InputTagTotal"
                      autoComplete="off"
                      value={
                        formatGermanFixedBy2(totalWareEingangAbschlag) ?? ""
                      }
                      disabled
                    />
                    {/* </div> */}
                  </td>
                  <td className="total_td_as_output">
                    {/* <input
                      className="wes1InputTagTotal"
                      autoComplete="off"
                      value={
                        formatGermanFixedBy2(
                          totalWareNachorderAusgangsAufschlag
                        ) ?? ""
                      }
                      disabled
                    /> */}
                    {formatGermanFixedBy2(
                      totalWareNachorderAusgangsAufschlag,
                    ) ?? ""}
                  </td>
                  <td className="total_td_as_output">
                    {/* <input
                      className="wes1InputTagTotal"
                      autoComplete="off"
                      value={
                        formatGermanFixedBy2(
                          totalWareNachorderAusgangsAbschlag
                        ) ?? ""
                      }
                      disabled
                    /> */}
                    {formatGermanFixedBy2(totalWareNachorderAusgangsAbschlag) ??
                      ""}
                  </td>
                  <td className="total_row_for_wes">
                    <input
                      className="wes1InputTagTotal"
                      autoComplete="off"
                      value={
                        formatGermanFixedBy2(totalWareAuslieferungsQuote) ?? ""
                      }
                      disabled
                    />
                  </td>
                  <td className="total_row_for_wes">
                    <input
                      className="wes1InputTagTotal"
                      autoComplete="off"
                      value={formatGermanFixedBy2(totalWareLUG) ?? ""}
                      disabled
                    />
                  </td>
                  <td className="total_row_for_wes">
                    <input
                      className="wes1InputTagTotal"
                      autoComplete="off"
                      value={
                        formatGermanFixedBy2(totalWareAbschriftPercent) ?? ""
                      }
                      disabled
                    />
                  </td>
                  {/* <td className="total_row_for_wes2">135.666</td> */}
                  <td className="total_td_as_output">
                    {/* <input
                      className="wes1InputTagTotal"
                      autoComplete="off"
                      value={formatGermanInputForDecimal(totalBestandAvg)}
                      disabled
                    /> */}
                    {formatGermanInputForDecimal(totalBestandAvg)}
                  </td>
                </>
              ) : null}
            </tr>
          </tfoot>
        </Table>
      </div>
      {/*  */}
    </div>
  );
};

export default PlanningWes1;
